import '~/pages/projects/show/index';
import Vue from 'vue';
import VueApollo from 'vue-apollo';
import initVueAlerts from '~/vue_alerts';
import initTierBadgeTrigger from 'ee/groups/init_tier_badge_trigger';
import createDefaultClient from '~/lib/graphql';
import ComplianceInfo from './components/compliance_info.vue';
import DuoOtelInfo from './components/duo_otel_info.vue';

const apolloProvider = new VueApollo({
  defaultClient: createDefaultClient(),
});

const initComplianceInfo = () => {
  const complianceInfoEl = document.getElementById('js-compliance-info');
  if (!complianceInfoEl) return false;
  const { projectPath, complianceCenterPath, canViewDashboard } = complianceInfoEl.dataset;
  return new Vue({
    el: complianceInfoEl,
    name: 'ComplianceInfoRoot',
    apolloProvider,
    render(h) {
      return h(ComplianceInfo, {
        props: {
          projectPath,
          complianceCenterPath,
          canViewDashboard,
        },
      });
    },
  });
};

const initDuoOtelInfo = () => {
  const el = document.getElementById('js-duo-otel-info');
  if (!el) return false;

  const { createWorkflowPath } = el.dataset;

  return new Vue({
    el,
    name: 'DuoOtelInfoRoot',
    render(h) {
      return h(DuoOtelInfo, {
        props: {
          createWorkflowPath,
        },
      });
    },
  });
};

initVueAlerts();
initTierBadgeTrigger();
initComplianceInfo();
initDuoOtelInfo();
